import { useAnswerManager } from 'pages/forms/hooks/useAnswerManager';
import { useFormData } from 'pages/forms/hooks/useFormData';
import { useCallback, useEffect } from 'react';
import { useAnswerFormFetcher } from '../useAnswerFormFetcher';
import moment from 'moment';
import { IRouterProps } from 'pages/orderHistory';
import { useSnackbar } from 'hooks';
import { useSuppliersContext } from 'contexts/SuppliersContext';

type Params = {
  params?: Record<string, string | undefined>;
  answersConfig: ReturnType<typeof useAnswerManager>;
};

export const useAnswerForm = ({ params, answersConfig, router }: Params & IRouterProps) => {
  const form = useFormData();
  const toast = useSnackbar();
  const answeredFetcher = useAnswerFormFetcher({ toast });
  const { answers } = answersConfig;
  const { currentSupplierId, supplierLoading } = useSuppliersContext();

  const handleSubmitAnswers = useCallback(async () => {
    await answeredFetcher.submitAnswers({ formId: Number(params?.id), supplierId: currentSupplierId, answers });
  }, [answers, currentSupplierId]);

  useEffect(() => {
    if (params && params.id && currentSupplierId) {
      const param = {
        id: Number(params?.id),
        supplierId: currentSupplierId
      };
      form.loadFormData(param);
    }
  }, [currentSupplierId]);

  useEffect(() => {
    if (form.formData && form.formData.endDate) {
      const formEndDate = form.formData.endDate;
      if (moment(formEndDate, 'DD/MM/YYYY').utc() < moment(new Date())) {
        router.push('formularios');
        toast.toggleSnackbar({
          message: 'Não é possivel responder um formulário encerrado.',
          type: 'error'
        });
      }
    }
  }, [form.formData]);

  return { ...form, ...answeredFetcher, ...toast, handleSubmitAnswers, supplierLoading };
};
